import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: true
})
export class TruncatePipe implements PipeTransform {
    transform(value: any[], limit: number): string {
        if (!Array.isArray(value)) {
            return '';
        }

        const remainingArray = value.slice(limit);

        if (remainingArray.length === 0) {
            return '';
        }

        const firstElement = remainingArray[0];

        switch (typeof firstElement) {
            case 'string':
            case 'number':
                return remainingArray.join(', ');
            case 'object':
                if (firstElement !== null) {
                    return remainingArray.map((item) => item.name).join(', ');
                }
                return '';
            default:
                return '';
        }
    }
}
